export default __webpack_public_path__ + "static/media/hkgrotesk-regular-webfont.7f9e2810.ttf";